import { render, staticRenderFns } from "./UsuarioView.vue?vue&type=template&id=0405b723"
import script from "./UsuarioView.vue?vue&type=script&lang=js"
export * from "./UsuarioView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports